import ForcesService from "../../services/ForcesService";

const state = {
    data: [],
}

const mutations = {
	SET_FORCES(state, forces) {
        state.data = forces;
    },
}

const actions = {
    fetch({commit}) {
        ForcesService.all().then( ({data}) => commit('SET_FORCES', data.data));
    }
}

const getters = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};